/**
 * @typedef {import('../types/KeyedObject').default} KeyedObject
 */

const array = require('./array');

/**
 * Concatenates URL parts, ensuring that extra slashes removed
 * @param {string | string[]} parts
 * @param {KeyedObject | URLSearchParams} [query]
 * @param {string} [hash]
 * @returns {string}
 */
function concat(parts, query, hash) {
	const url = array
		.wrap(parts)
		.map((string) => string.replace(/^\/|\/$/g, ''))
		.filter(Boolean)
		.join('/');

	const end = hash === undefined ? '' : `#${hash}`;

	if (query === undefined) {
		return url + end;
	}

	if (query instanceof URLSearchParams) {
		return `${url}?${query.toString()}${end}`;
	}

	if (Object.keys(query).length === 0) {
		return url + end;
	}

	const queryString = new URLSearchParams(query).toString();

	return `${url}?${queryString}${end}`;
}

/**
 * Implementation of PHP's `rawurlencode`
 * @see {@link https://www.php.net/manual/en/function.rawurlencode.php | PHP function documentation for reference}
 * @param {string} string
 * @returns {string}
 */
function rawurlencode(string) {
	return encodeURIComponent(string)
		.replace(/!/g, '%21')
		.replace(/'/g, '%27')
		.replace(/\(/g, '%28')
		.replace(/\)/g, '%29')
		.replace(/~/g, '%7E')
		.replace(/\*/g, '%2A');
}

module.exports = {
	concat,
	rawurlencode,
};
